import styled from 'styled-components';

export const AppliedVoucherCodesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const AppliedVoucherCodesItem = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content min-content;
  gap: 10px;
  border: 1px solid ${({ theme }) => theme.defaultColors.darkGrey};
  background-color: ${({ theme }) => theme.defaultColors.lighterGrey};
  padding: 16px;
  border-radius: 3px;
`;

export const AppliedVoucherCodesItemRemoveButton = styled.button`
  cursor: pointer;
  color: ${({ theme }) => theme.defaultColors.requiredRed};
  font-size: 14px;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
`;

export const AppliedVoucherCodesItemCode = styled.span`
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
`;

export const AppliedVoucherCodesItemName = styled.span`
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  grid-column: 1 / 3;
`;

export const AppliedVoucherCodesItemRedemptionTotal = styled.span`
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
`;
